import { render, staticRenderFns } from "./ageTj.vue?vue&type=template&id=5d85dcbc&scoped=true&"
import script from "./ageTj.vue?vue&type=script&lang=js&"
export * from "./ageTj.vue?vue&type=script&lang=js&"
import style0 from "./ageTj.vue?vue&type=style&index=0&id=5d85dcbc&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d85dcbc",
  null
  
)

export default component.exports